export const enum UserEnumerations {
  CONTACT_PREFERENCES = '/users/enums/contact-preferences',
  CREDENTIALS = '/users/enums/credentials',
  CAPACITY = '/users/enums/capacity',
  ETHNICITIES = '/users/enums/ethnicities',
  GENDERS = '/users/enums/genders',
  LANGUAGES = '/users/enums/languages',
  PRONOUNS = '/users/enums/pronouns',
  PROVIDER_TYPES = '/users/enums/provider-types',
  REGIONS = '/users/enums/regions',
  RELATIONS_TO_PATIENT = '/users/enums/relations-to-patient',
  SEXES = '/users/enums/sexes',
  TAGS = '/users/enums/tags',
  STATES = 'clinical-data/us-states',
  TIMEZONES = '/users/enums/timezones',
}
